const ID_CACHE = /* @__PURE__ */ new WeakMap();
let AUTO_INCREMENTED_ID = 0;
function generateValueId(variable) {
  if (isPrimitive(variable)) {
    return `str_${variable}`;
  }
  if (isSymbol(variable)) {
    return `sym_${variable.toString()}`;
  }
  let cacheKey = ID_CACHE.get(variable);
  if (!cacheKey) {
    cacheKey = `obj_${++AUTO_INCREMENTED_ID}`;
    ID_CACHE.set(variable, cacheKey);
  }
  return cacheKey;
}
function isPrimitive(value) {
  return !value || typeof value === "string" || typeof value === "number" || typeof value === "bigint" || typeof value === "boolean";
}
function isSymbol(value) {
  return typeof value === "symbol";
}

export { generateValueId };
//# sourceMappingURL=generate-value-id.js.map
